import { useMemo, useState } from "react";
import { Box, Typography, Modal } from "@material-ui/core";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import DataTable from "../../../components/DataTable";
import useSystemLogs from "./useSystemLogs";
import { formatDate } from "../../../utils/Utils";
import { LOGS_FILTERS } from "./useSystemLogs";

export default function SystemLogs() {
  const {
    data,
    incompanys,
    totalRecords,
    isLoading,
    currentPage,
    rowsPerPage,
    currentFilters,
    handlePageChange,
    handleRowsPerPageChange,
    handleSubmitFilters,
    handleResetFilters,
    refreshData,
  } = useSystemLogs();

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);

  const handleOpenModal = (row) => {
    setSelectedLog(row);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedLog(null);
  };

  const tableRows = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.map((item) => ({
      id_pessoa: item.id_pessoa || "-",
      action: item.actions || "-",
      nome_pessoa: item.pessoa?.nome || "-",
      email_pessoa: item.pessoa?.email || "-",
      created_at: item.created_at
        ? formatDate(item.created_at, "dd/MM/yyyy HH:mm")
        : "-",
    }));
  }, [data, refreshData]);

  const columns = useMemo(
    () => [
      {
        key: "id_pessoa",
        name: "ID Pessoa",
        isSingleLine: true,
        sortable: true,
      },
      {
        key: "nome_pessoa",
        name: "Nome",
        isSingleLine: true,
        maxWidth: "300px",
        sortable: true,
      },
      {
        key: "email_pessoa",
        name: "Email",
        isSingleLine: true,
        maxWidth: "300px",
        sortable: true,
      },
      {
        key: "action",
        name: "Log",
        isSingleLine: true,
        maxWidth: "200px",
        sortable: true,
        renderCustomRow: (row) => (
          <Typography 
            onClick={() => handleOpenModal(row)}
            style={{ cursor: 'pointer' }}
          >
            {row.action}
          </Typography>
        ),
      },
      {
        key: "created_at",
        name: "Data Registro",
        isSingleLine: true,
        maxWidth: "200px",
        sortable: true,
      },
    ],
    []
  );

  return (
    <Box width="100%" paddingLeft="250px">
      <Box width="100%" padding="1rem">
        <AdminMenu />
        <DataTable
          showFilters
          showPagination
          defaultOpenedFilters
          maxHeight="70vh"
          hasStickHeader
          filters={[
            {
              key: LOGS_FILTERS.SEARCH,
              name: "Buscar",
              component: {
                type: "text",
                placeholder:
                  "Busque pelo ID do aluno, Nome do aluno, Email do aluno ou pelo log",
              },
            },
            {
              key: LOGS_FILTERS.ID_INCOMPANY,
              name: "Empresa",
              component: {
                type: "select",
                options: [
                  { name: "Todas as Empresas", key: "Todas as Empresas" },
                  ...incompanys.map((incompany) => ({
                    name: incompany.name,
                    key: incompany.id,
                  })),
                ],
              },
            },
            {
              key: LOGS_FILTERS.DATE_START,
              name: "De",
              component: { type: "datetime-local" },
            },
            {
              key: LOGS_FILTERS.DATE_END,
              name: "Até",
              component: { type: "datetime-local" },
            },
          ]}
          columns={columns}
          rows={tableRows}
          page={currentPage}
          rowsPerPage={rowsPerPage}
          isLoading={isLoading}
          selectedFilters={currentFilters}
          totalRecords={totalRecords}
          onPageChange={handlePageChange}
          onRowsPerChange={handleRowsPerPageChange}
          onSubmitFilters={handleSubmitFilters}
          onResetFilters={handleResetFilters}
          CustomToolbarElement={
            <Typography variant="h5" component="h1">
              Logs do Sistema
            </Typography>
          }
        />
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
        >
          <Box 
            style={{ 
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 600,
              backgroundColor: 'white',
              border: '2px solid #000',
              boxShadow: 24,
              padding: '16px',
            }}
          >
            <Typography variant="h6" component="h2">
              Detalhes do Log
            </Typography>
            <Typography component="pre" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginTop: '16px' }}>
              {selectedLog?.action}
            </Typography>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
}
